import MasterServicesContainer from 'modules/masterServices/containers/MasterServicesContainer';

const MasterServicesView = props => <MasterServicesContainer {...props} />;

export default MasterServicesView;
